/**
 * 文字选择性粘贴状态
 * 由于选择性粘贴中可能会涉及到多次 changeset，比如需要先 undo 上次粘贴结果，再执行新的粘贴
 * 单纯从流程上很难判断出当前是否在选择性粘贴过程中，这个类就是协助标记这个状态
 */
export default class TextSelectivePasteState {
    // 是否在执行选择性粘贴中
    private isPasting = false;
    private pasteCallbacks: Set<() => void> = new Set();


    /**
     * 选择性粘贴前调用，标记状态
     */
    public beforePaste() {
        this.isPasting = true;
    }

    /**
     * 选择性粘贴后调用，重置状态
     */
    public afterPaste() {
        this.isPasting = false;
        this.executeCallbacks();
    }

    /**
     * 获取粘贴状态
     */
    public checkIsPasting() {
        return this.isPasting;
    }

    /**
     * 添加粘贴后执行的回调
     * 返回值为清除函数
     */
    public executeAfterPaste(callback: () => void): () => void {
        this.pasteCallbacks.add(callback);
        return () => {
            this.pasteCallbacks.delete(callback);
        };
    }

    private executeCallbacks() {
        this.pasteCallbacks.forEach(callback => callback());
    }
}
